module.exports = __webpack_public_path__ + "img/rang9.d9ea423d.png";